module.exports = __webpack_public_path__ + "img/wx_pay.bd0b540c.png";